var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"white"},attrs:{"id":"marquee"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.isamnet},on:{"load":_vm.onLoad}}),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.isamnet}}),_c('div',{staticClass:"ucmarquee-wrapper",style:(_vm.creative.offset_bottom_number
        ? ("bottom:" + (_vm.creative.offset_bottom_number) + (_vm.creative.offset_bottom_unit))
        : "")},[(_vm.creative.closeBtnType==0)?_c('a',{staticClass:"closebutton",on:{"click":function($event){return _vm.close()}}}):_vm._e(),(_vm.creative.closeBtnType==1)?_c('div',{staticClass:"closebutton",style:({
        position: "absolute",
        display: "block",
        width: "14px",
        height: "14px",
        zIndex: "50000",
        bottom: "130px",
        backgroundSize: "contain",
        borderRadius: "16px",
        top: (_vm.top + "px"),
        right: (_vm.right + "px"),
        backgroundColor: "transparent",
        backgroundImage: "none",
    })},[_c('svg',{staticStyle:{"border":"0px solid black","position":"absolute"},attrs:{"width":"14","height":"14"}},[_c('circle',{attrs:{"cx":"7","cy":"7","r":"6","fill":"gray","fill-opacity":"0.3","stroke":"black","stroke-width":"0"}}),_c('line',{attrs:{"x1":"3","y1":"3","x2":"11","y2":"11","stroke":"black","stroke-width":"1.5"}}),_c('line',{attrs:{"x1":"3","y1":"11","x2":"11","y2":"3","stroke":"black","stroke-width":"1.5"}})]),_c('a',{style:({
          position: "absolute",
          display: "block",
          width: "11px",
          height: "11px",
          zIndex: "50000",
          bottom: "130px",
          backgroundSize: "contain",
          borderRadius: "16px",
          top: "1.5px",
          right: "1.5px",
          backgroundColor: "transparent",
          backgroundImage: "none",
        }),on:{"click":function($event){return _vm.close()}}})]):_vm._e(),_c('div',{staticClass:"ucmarquee-container",style:({
        width: _vm.creative.images.length * 100 + 'vw',
      })},[_c('a',{attrs:{"href":_vm.creative.landing_page,"target":"_blank"}},_vm._l((_vm.creativeImages),function(img,index){return _c('img',{key:index,ref:'item-' + index,refInFor:true,attrs:{"src":img.url},on:{"load":_vm.onLoad}})}),0)])])])}
var staticRenderFns = []

export { render, staticRenderFns }